import React from "react";
import { SEO } from "../../seo/SEO";
import styled from "styled-components";
import { useTypedResource } from "../../i18n/languagehandler";

const Section = styled.section`
  max-width: 900px;
  margin: 40px auto 0;
  padding: 0 20px;
`;

const Title = styled.h1`
  color: var(--text);
  font-size: 36px;
  margin: 0 0 30px 0;
  line-height: 1.2;
`;

const Content = styled.div`
  color: var(--text);
  font-size: 16px;
  line-height: 1.6;

  h2 {
    color: var(--primary);
    font-size: 24px;
    margin: 30px 0 15px 0;
    font-weight: 600;
  }

  h3 {
    color: var(--text);
    font-size: 20px;
    margin: 25px 0 12px 0;
    font-weight: 600;
  }

  p {
    margin: 0 0 16px 0;
  }

  ul,
  ol {
    margin: 16px 0;
    padding-left: 20px;
  }

  li {
    margin: 8px 0;
  }

  strong {
    font-weight: 600;
    color: var(--text);
  }

  a {
    color: var(--primary);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Impressum: React.FC = () => {
  const res = useTypedResource<{
    title: string;
    content: string;
  }>("impressum");

  return (
    <main>
      <SEO
        title={res.title}
        description="Legal information"
        path="/impressum"
      />
      <Section>
        <Title>{res.title}</Title>
        <Content dangerouslySetInnerHTML={{ __html: res.content }} />
      </Section>
    </main>
  );
};
